/* eslint-disable react/no-array-index-key */
'use client'

import { Container } from '@/ui/layouts/container/Container'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { TextSkeleton } from '@/ui/skeleton/TextSkeleton'
import { TabsSkeleton } from '@/ui/tabs/TabsSkeleton'
import { Skin } from '@/ui/skin/Skin'

function ReferencesProductSkeletonMobile(): React.ReactElement {
  return (
    <div className="mt-2 space-y-3 desktop:hidden">
      <div className="flex items-center gap-x-1">
        <BaseSkeleton className="h-5 w-15" />
        <BaseSkeleton className="h-5 w-15" />
      </div>
      <TextSkeleton size="xl" leading="normal" className="w-20" />
      <div className="space-y-4">
        {Array.from({ length: 2 }).map((_, index) => (
          <div key={index} className="flex flex-col gap-y-2 bg-white p-2">
            <div className="flex gap-x-2">
              <BaseSkeleton className="size-16" />
              <div className="space-y-1">
                <TextSkeleton size="md" leading="normal" className="w-10" />
                <TextSkeleton size="md" leading="normal" className="w-[15rem]" />
                <TextSkeleton size="xl" leading="normal" className="w-20" />
                <TextSkeleton size="md" leading="normal" className="w-15" />
                <TextSkeleton size="md" leading="normal" className="w-22" />
              </div>
            </div>
            <div className="space-y-1">
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="flex gap-x-1">
                  <BaseSkeleton className="h-4 w-2/3" />
                  <BaseSkeleton className="h-4 w-1/3" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function ReferencesProductSkeletonDesktop(): React.ReactElement {
  return (
    <div className="hidden justify-center py-2 desktop:flex">
      <TabsSkeleton variant="md" count={4} className="w-full max-w-4xl" />
    </div>
  )
}

export function ReferencesProductSkeleton() {
  return (
    <Skin tint="body-alt" className="relative py-3 pt-1 desktop:pt-3">
      <Container>
        <ReferencesProductSkeletonMobile />
        <ReferencesProductSkeletonDesktop />
      </Container>
    </Skin>
  )
}
